import moment from 'moment/moment';
import BaseServiceCrud from './BaseServiceCrud';
import Constants from '../utils/constants';

export default class UserTransportService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user-transport';
    }

    getCriteria(criteria) {
        console.log(criteria.transport?.transportId);
        const queryString = this.objToQueryString({
            locale: criteria.locale,
            transportId: criteria.transport?.transportId,
            date: criteria.date ? moment(criteria.date).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            percentageDeviation: criteria?.percentageDeviation,
            startTravelDate: criteria.startTravelDate ? moment(criteria.startTravelDate).format(Constants.DATE_TIME_FORMAT) : null,
            finishTravelDate: criteria.startTravelDate ? moment(criteria.finishTravelDate).format(Constants.DATE_TIME_FORMAT) : null,
            direction: criteria?.direction?.enumValue,
            directions:
                criteria?.directions?.length === 0 || criteria?.directions === undefined || criteria?.directions === null
                    ? []
                    : criteria?.directions,
            userName: criteria?.userName,
            userRequestedInclude: criteria?.userRequestedInclude,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            userId: criteria?.userId,
            //transportId: criteria?.transportId,
            travelCredited: criteria.travelCredited?.enumValue
        });
        return queryString;
    }

    getDetailsList(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/details/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    saveFake(req) {
        return this.fetch(`${this.domain}/${this.path}/save-fake`, {
            method: 'POST',
            body: JSON.stringify(req),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    exclude(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/exclude/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    include(id, direction) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/include/${id}/${direction == null ? 'UNSET' : direction}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    rejectInclude(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/reject-include/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateRewards(id, request) {
        return this.fetch(`${this.domain}/${this.path}/${id}/rewards`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => Promise.resolve(res));
    }
}
